import React from "react"
import styled from "styled-components"
import { H2 } from "@carrotfertility/carotene"
import { DynamicContentMarkdown, getStyleOverridesClone } from "../../dynamic-content/DynamicContentMarkdown"

interface GuidanceProps {
  title: string
  description: string
}

const GuidanceH2 = styled(H2)`
  margin-bottom: 8px;
  color: black;
`

const TTCstyleOverrides = getStyleOverridesClone()
TTCstyleOverrides.p = styled.p.attrs({ className: "black-60" })`
  margin-bottom: 21px;
  font-size: 14px;
  line-height: 150%;
  font-family: "Gotham A", "Gotham B", sans-serif;
  &:last-child {
    margin-bottom: 0;
  }
`

const Guidance = ({ title, description }: GuidanceProps) => (
  <>
    <GuidanceH2 stack={"tiny"}>{title}</GuidanceH2>
    <DynamicContentMarkdown source={description} styleOverrides={TTCstyleOverrides} />
  </>
)

export default Guidance
